// BEGIN sps2BlueGalleryScenes20260717
;(function sps2BlueGalleryScenes20260717() {
  var config = {
  "handle": "seibertron-sps-2-unisex-touchscreen-road-racing-motorcycle-mtb-sports-gloves",
  "targetColor": "SPS-2 Full Finger Adult Blue",
  "colorMediaMap": {
    "SPS-2 Full Finger Adult Blue": "30826113204414",
    "SPS-2 Full Finger Adult White": "31065751027902",
    "SPS-2 Full Finger Adult Black": "31065751978174",
    "SPS-2 Full Finger Adult Orange": "31065753387198",
    "SPS-5 Half Finger Adult White": "31065774817470",
    "SPS-5 Half Finger Adult Black": "31065777635518",
    "SPS-5 Half Finger Adult Orange": "31065778651326",
    "SPS-2 Full Finger Adult FL Yellow": "31065753977022",
    "SPS-5 Half Finger Adult Grey": "31065779241150",
    "SPS-5 Half Finger Adult Pink": "31065779503294",
    "SPS-5 Half Finger Adult FL Yellow": "31065780125886"
  },
  "singleEntries": {
    "31065751027902": {
      "id": "31065751027902",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-31065751027902.png?v=1769483042",
      "alt": "SPS-2 Full Finger Adult White | white leather motorcycle gloves"
    },
    "31065751978174": {
      "id": "31065751978174",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-31065751978174.png?v=1769483049",
      "alt": "SPS-2 Full Finger Adult Black | black motorcycle gloves"
    },
    "31065753387198": {
      "id": "31065753387198",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-31065753387198.png?v=1769483030",
      "alt": "SPS-2 Full Finger Adult Orange | orange riding gloves"
    },
    "31065753977022": {
      "id": "31065753977022",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/yellow_leather_motorcycle_gloves.png?v=1763717865",
      "alt": "SPS-2 Full Finger Adult FL Yellow | yellow motorcycle gloves"
    },
    "31065774817470": {
      "id": "31065774817470",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/half_gloves_for_motorcycle.png?v=1763716813",
      "alt": "SPS-5 Half Finger Adult White | motorcycle gloves"
    },
    "31065777635518": {
      "id": "31065777635518",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/half_biker_gloves.png?v=1767949767",
      "alt": "SPS-5 Half Finger Adult Black | half finger motorcycle riding gloves"
    },
    "31065778651326": {
      "id": "31065778651326",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/best_half_finger_motorcycle_gloves.png?v=1763716749",
      "alt": "SPS-5 Half Finger Adult Orange | biker gloves half"
    },
    "31065779241150": {
      "id": "31065779241150",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/half_finger_gloves_for_motorcycle.png?v=1768012113",
      "alt": "SPS-5 Half Finger Adult Grey | half finger gloves motorcycle"
    },
    "31065779503294": {
      "id": "31065779503294",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/pink_motorcycle_gloves.png?v=1763716830",
      "alt": "SPS-5 Half Finger Adult Pink | motorcycle gloves pink"
    },
    "31065780125886": {
      "id": "31065780125886",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/half_finger_motorcycle_gloves.png?v=1763716688",
      "alt": "SPS-5 Half Finger Adult FL Yellow | motorcycle half gloves"
    }
  },
  "targetVariantId": "42778125762750",
  "blueVariantIds": [
    "42778125762750",
    "42778125795518",
    "42778125828286",
    "42778125861054",
    "42778125893822",
    "42851759423678",
    "47819473780926",
    "47819473813694",
    "47819473846462",
    "47819473879230",
    "47819473911998"
  ],
  "originalSafeGallery": "|30826113204414|30826113237182|30826113171646|30826113138878|27646064951486|25867617697982|25867615371454|25867616551102|27646068555966|27646069539006|27646067114174|",
  "entries": [
    {
      "id": "30826113204414",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-30826113204414.jpg?v=1771054332",
      "alt": "Seibertron Youth SPS-2/ SPS-5 Unisex Touchscreen Road Racing Motorcycle Gloves MTB Sports - Seibertron",
      "width": 1000,
      "height": 1000
    },
    {
      "id": "28742152880318",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-28742152880318.jpg?v=1769483030",
      "alt": "Seibertron SPS-2 Full Finger Unisex Touchscreen Road Racing Motorcycle MTB Sports Gloves - Seibertron",
      "width": 1000,
      "height": 1000
    },
    {
      "id": "28742153175230",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-28742153175230.jpg?v=1769483030",
      "alt": "Seibertron SPS-2 Full Finger Unisex Touchscreen Road Racing Motorcycle MTB Sports Gloves - Seibertron",
      "width": 1000,
      "height": 1000
    },
    {
      "id": "28742152585406",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-28742152585406.jpg?v=1769483030",
      "alt": "Seibertron SPS-2 Full Finger Unisex Touchscreen Road Racing Motorcycle MTB Sports Gloves - Seibertron",
      "width": 1000,
      "height": 1000
    },
    {
      "id": "28742152749246",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-28742152749246.jpg?v=1769483030",
      "alt": "Seibertron SPS-2 Full Finger Unisex Touchscreen Road Racing Motorcycle MTB Sports Gloves - Seibertron",
      "width": 1000,
      "height": 1000
    },
    {
      "id": "28742152323262",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-28742152323262.jpg?v=1769483030",
      "alt": "Seibertron SPS-2 Full Finger Unisex Touchscreen Road Racing Motorcycle MTB Sports Gloves - Seibertron",
      "width": 1000,
      "height": 1000
    },
    {
      "id": "29355385454782",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/Seibertron-Adult-SPS-2-SPS-5-Unisex-Touchscreen-Road-Racing-Motorcycle-MTB-Sports-Gloves-Seibertron-29355385454782.jpg?v=1769483030",
      "alt": "sps-7",
      "width": 1000,
      "height": 1000
    }
  ]
};
  var applying = false;
  var originalThumbState = new WeakMap();
  var originalMainState = new WeakMap();
  var originalSafeState = new WeakMap();

  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedColor(scope) {
    var input = scope.querySelector('input[name="options[Color]"]:checked');
    return input ? String(input.value || '') : '';
  }
  function variantFromUrl() {
    try { return new URL(window.location.href).searchParams.get('variant') || ''; }
    catch (error) { return ''; }
  }
  function active(scope) {
    var color = selectedColor(scope);
    if (color) return color === config.targetColor;
    return config.blueVariantIds.indexOf(variantFromUrl()) !== -1;
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    if (!originalMainState.has(main)) {
      originalMainState.set(main, {
        src: main.getAttribute('src'),
        srcset: main.getAttribute('srcset'),
        alt: main.getAttribute('alt')
      });
    }
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || '';
    main.setAttribute('data-sps2-blue-gallery-main', entry.id);
  }
  function restoreMain(scope) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main) return;
    var state = originalMainState.get(main);
    if (state) {
      if (state.src == null) main.removeAttribute('src'); else main.setAttribute('src', state.src);
      if (state.srcset == null) main.removeAttribute('srcset'); else main.setAttribute('srcset', state.srcset);
      if (state.alt == null) main.removeAttribute('alt'); else main.setAttribute('alt', state.alt);
      originalMainState.delete(main);
    }
    main.removeAttribute('data-sps2-blue-gallery-main');
  }
  function saveThumb(thumb) {
    if (originalThumbState.has(thumb)) return;
    originalThumbState.set(thumb, {
      hidden: thumb.hidden,
      display: thumb.style.display,
      ariaHidden: thumb.getAttribute('aria-hidden')
    });
  }
  function restoreThumb(thumb) {
    var state = originalThumbState.get(thumb);
    if (!state) return;
    thumb.hidden = state.hidden;
    thumb.style.display = state.display;
    if (state.ariaHidden == null) thumb.removeAttribute('aria-hidden');
    else thumb.setAttribute('aria-hidden', state.ariaHidden);
    originalThumbState.delete(thumb);
  }
  function bindThumb(scope, thumb, entry) {
    if (thumb.getAttribute('data-sps2-blue-gallery-bound') === 'true') return;
    thumb.setAttribute('data-sps2-blue-gallery-bound', 'true');
    thumb.addEventListener('click', function () {
      if (!active(scope)) return;
      setMain(scope, entry);
      scope.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
        node.classList.toggle('is-active', node === thumb);
      });
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      thumb.setAttribute('data-sps2-blue-gallery-generated', 'true');
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' +
        escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
      wrap.appendChild(thumb);
    }
    saveThumb(thumb);
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    bindThumb(scope, thumb, entry);
    return thumb;
  }
  function apply(scope) {
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    if (!originalSafeState.has(scope)) {
      originalSafeState.set(scope, scope.getAttribute('data-safe-gallery-media-ids'));
    }
    var desired = {};
    config.entries.forEach(function (entry) { desired[entry.id] = true; });
    scope.setAttribute('data-safe-gallery-media-ids', '|' +
      config.entries.map(function (entry) { return entry.id; }).join('|') + '|');
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    wrap.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      saveThumb(thumb);
      var keep = !!desired[String(thumb.getAttribute('data-media-id') || '')];
      thumb.hidden = !keep;
      thumb.style.display = keep ? '' : 'none';
      thumb.setAttribute('aria-hidden', keep ? 'false' : 'true');
    });
    scope.setAttribute('data-sps2-blue-gallery-active', 'true');
    var currentMainId = (scope.querySelector('[data-auto-main-image]') || {}).getAttribute
      ? scope.querySelector('[data-auto-main-image]').getAttribute('data-sps2-blue-gallery-main')
      : '';
    if (!desired[currentMainId]) setMain(scope, config.entries[0]);
  }
  function restore(scope) {
    scope.querySelectorAll('[data-sps2-blue-gallery-generated="true"]').forEach(function (thumb) {
      thumb.remove();
    });
    scope.querySelectorAll('[data-auto-thumb]').forEach(restoreThumb);
    restoreMain(scope);
    var safeState = originalSafeState.get(scope);
    if (safeState == null) {
      if (config.originalSafeGallery) scope.setAttribute('data-safe-gallery-media-ids', config.originalSafeGallery);
      else scope.removeAttribute('data-safe-gallery-media-ids');
    } else {
      scope.setAttribute('data-safe-gallery-media-ids', safeState);
    }
    originalSafeState.delete(scope);
    scope.removeAttribute('data-sps2-blue-gallery-active');
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    applying = true;
    var color = selectedColor(scope);
    if (active(scope)) apply(scope);
    else restore(scope);
    applying = false;
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.getAttribute('data-sps2-blue-gallery-listeners') === 'true') return;
    scope.setAttribute('data-sps2-blue-gallery-listeners', 'true');
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) {
        window.setTimeout(hydrate, delay);
      });
    });
    var observer = new MutationObserver(function () {
      if (!applying) window.setTimeout(hydrate, 10);
    });
    observer.observe(scope, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden', 'style', 'aria-hidden', 'data-safe-gallery-media-ids']
    });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [100, 350, 900, 1800, 3500, 7000].forEach(function (delay) { window.setTimeout(run, delay); });
  window.setInterval(hydrate, 500);
})();
// END sps2BlueGalleryScenes20260717
